module.exports = __webpack_public_path__ + "images/logo_horizontal.b0ddad3429b7928236313805437dffe7.png";